const Backbone = require("backbone");

class UserOnboardedFeature extends Backbone.Model {
  featureName() {
    return this.get("featureName");
  }
}

module.exports = UserOnboardedFeature;
